export default {
  en: {
    'pages-filing-filing-detail-page-components-filing-outcome-components.payment-details-form.payment-details.label':
      'Payment details',
    'pages-filing-filing-detail-page-components-filing-outcome-components.payment-details-form.payment-details.confirmClose.unsaved-changes':
      'You have unsaved changes. Are you sure you want to continue?',
    'pages-filing-filing-detail-page-components-filing-outcome-components.payment-details-form.payment-details.confirmClose.discard':
      'Discard changes',
    'pages-filing-filing-detail-page-components-filing-outcome-components.payment-details-form.payment-details.confirmClose.continue':
      'Continue editing',
  },
};
